// Background hero video: honours reduced motion and exposes a --toggle command for the visible pause control.
class SHeroVideo extends HTMLElement {
  #abort = null;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    this.video = this.querySelector('video');
    if (!this.video) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduced.matches) this.#pause();

    this.addEventListener('command', (event) => {
      if (event.command !== '--toggle') return;
      if (this.video.paused) this.#play();
      else this.#pause();
    }, { signal });

    this.video.addEventListener('play', () => this.#sync(), { signal });
    this.video.addEventListener('pause', () => this.#sync(), { signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #play() {
    this.video.play().catch(() => {});
  }

  #pause() {
    this.video.pause();
  }

  #sync() {
    const button = document.querySelector(`[commandfor="${this.id}"][data-hero-toggle]`);
    if (!button) return;
    const paused = this.video.paused;
    button.setAttribute('aria-label', paused ? this.dataset.labelPlay : this.dataset.labelPause);
    button.querySelector('[data-icon-pause]')?.toggleAttribute('hidden', paused);
    button.querySelector('[data-icon-play]')?.toggleAttribute('hidden', !paused);
  }
}

if (!customElements.get('s-hero-video')) customElements.define('s-hero-video', SHeroVideo);
